// ═══════════════════════════════════════════════════════════════════════════════
// RESPONSE ASSISTANT PAGE - Page dédiée à l'assistant réponses
// ═══════════════════════════════════════════════════════════════════════════════

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Brain } from 'lucide-react';
import ResponseAssistant from '../../components/ai/ResponseAssistant';

export default function ResponseAssistantPage() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-gray-600" />
          </button>
          <div className="flex items-center gap-2">
            <Brain className="w-5 h-5 text-[#1E3A5F]" />
            <h1 className="font-semibold text-gray-900">Assistant Réponses</h1>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="max-w-2xl mx-auto p-4 py-8">
        <ResponseAssistant />
      </div>
    </div>
  );
}
